import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppointmentFrequencyComponent } from './appointment-frequency.component';
import {
  MatDatepickerModule, MAT_DATE_LOCALE, MatSelectModule,
  MatFormFieldModule, MatNativeDateModule, MatInputModule
} from '@angular/material';
import { IonicModule } from '@ionic/angular';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '../../../shared/translate/translate.module';

@NgModule({
  declarations: [AppointmentFrequencyComponent],
  imports: [
    CommonModule,
    IonicModule,
    MatDatepickerModule,
    MatSelectModule,
    MatFormFieldModule,
    MatNativeDateModule,
    MatInputModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule
  ],
  exports: [
    AppointmentFrequencyComponent
  ],
  providers: [
    MatDatepickerModule,
    { provide: MAT_DATE_LOCALE, useValue: 'hu-HU' }
  ]
})
export class AppointmentFrequencyModule { }
